export default function (store, config) {
    store.setState({
        stateCombo: config,
    });
}
//# sourceMappingURL=combo.js.map